import React, { FC } from 'react'
import styled from 'styled-components'
import SalesOrigin from '../DashboardCharts/SalesOrigin'
import { SERIES_BASE, SERIES_COMPARE } from './styles'

/**
 * Origem das vendas (OP-3419) no Comparativo de Eventos: reusa o endpoint
 * group-aware e o componente SalesOrigin, mostrando lado A × lado B para
 * comparar de onde vieram as vendas de cada evento (canal, campanha, física).
 */

const FAINT = '#B0B0B0'
const INK = '#212121'
const BORDER = '#EAECF0'

const SectionHead = styled.div`
  display: flex;
  align-items: baseline;
  gap: 10px;
  margin: 24px 0 12px;
`
const Kicker = styled.span`
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.08em;
  color: ${FAINT};
  text-transform: uppercase;
`
const Name = styled.h2`
  font-size: 15px;
  font-weight: 680;
  color: ${INK};
  margin: 0;
`
const Grid2 = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  margin-bottom: 24px;
  @media (max-width: 980px) {
    grid-template-columns: 1fr;
  }
`
const Card = styled.div<{ $accent: string }>`
  background: #fff;
  border: 1px solid ${BORDER};
  border-top: 3px solid ${(p) => p.$accent};
  border-radius: 14px;
  box-shadow: 0 1px 3px rgba(16, 24, 40, 0.1), 0 1px 2px rgba(16, 24, 40, 0.06);
  padding: 18px;
  display: flex;
  flex-direction: column;
  gap: 14px;
`
const CardTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14.5px;
  font-weight: 660;
  color: ${INK};
`
const Dot = styled.span<{ $color: string }>`
  width: 10px;
  height: 10px;
  border-radius: 3px;
  background: ${(p) => p.$color};
  flex-shrink: 0;
`
const Empty = styled.div`
  font-size: 12.5px;
  color: ${FAINT};
  padding: 8px 0;
`

interface Props {
  baseName: string
  compareName: string
  baseOrigin: any
  compareOrigin: any
  baseLoading?: boolean
  compareLoading?: boolean
}

const Side: FC<{ name: string; color: string; origin: any; loading?: boolean }> = ({
  name,
  color,
  origin,
  loading,
}) => (
  <Card $accent={color}>
    <CardTitle>
      <Dot $color={color} />
      {name}
    </CardTitle>
    {origin ? (
      <SalesOrigin data={origin} compact />
    ) : (
      <Empty>{loading ? 'Carregando origem das vendas…' : 'Sem dados de origem no período.'}</Empty>
    )}
  </Card>
)

const OriginComparison: FC<Props> = ({
  baseName,
  compareName,
  baseOrigin,
  compareOrigin,
  baseLoading,
  compareLoading,
}) => {
  return (
    <>
      <SectionHead>
        <Kicker>Origem</Kicker>
        <Name>Origem das vendas</Name>
      </SectionHead>
      <Grid2>
        <Side name={baseName} color={SERIES_BASE} origin={baseOrigin} loading={baseLoading} />
        <Side
          name={compareName}
          color={SERIES_COMPARE}
          origin={compareOrigin}
          loading={compareLoading}
        />
      </Grid2>
    </>
  )
}

export default OriginComparison
